import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormValidation } from 'calidation';
import * as authenticateActions from '../../actions/authenticateActions';
import { notify } from '../../util/notifications';
import { getPermissionByName } from '../../util/customMethods';

class MfaLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      otp: '', // Added OTP to state to handle it consistently
      showOtpForm: false,
      isLoading: false,
      errorMessage: ''
    };
    this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
    this.handleOtpSubmit   = this.handleOtpSubmit.bind(this);
    this.switchToPasswordLogin = this.switchToPasswordLogin.bind(this);
    this.handleOtpChange = this.handleOtpChange.bind(this); // Added handler for OTP field changes
  }

  handleEmailSubmit(fields, errors, isValid) {
    if (fields.isValid) {
      this.setState({ isLoading: true, errorMessage: '' });
      const { dispatch } = this.props;

      dispatch(
        authenticateActions.checkEmailDomain(fields.fields.email,
          () => {
            dispatch(
              authenticateActions.generateOtp(fields.fields.email,
                () => {
                  this.setState({
                    isLoading: false,
                    showOtpForm: true,
                    email: fields.fields.email
                  });
                  notify.createNotification(
                    'success',
                    'Verification code sent to your email',
                    this.props.refNotify
                  );
                },
                (otpFail) => {
                  this.setState({
                    isLoading: false,
                    errorMessage: otpFail.statusMsg || 'Failed to send verification code'
                  });
                  notify.createNotification('error', this.state.errorMessage, this.props.refNotify);
                }
              )
            );
          },
          (fail) => {
            this.setState({
              isLoading: false,
              errorMessage: fail.statusMsg || 'Your email domain is not authorized'
            });
            notify.createNotification('error', this.state.errorMessage, this.props.refNotify);
          }
        )
      );
    }
  }

  // Add a handler for OTP field changes to manage it in component state
  handleOtpChange(event) {
    this.setState({ otp: event.target.value });
  }

  handleOtpSubmit(fields, errors, isValid) {
    // Use local state value if fields.fields.otp is undefined or empty
    const otpValue = (fields.fields && fields.fields.otp) ? fields.fields.otp : this.state.otp;
    
    if (fields.isValid || (otpValue && otpValue.length === 6)) {
      this.setState({ isLoading: true, errorMessage: '' });
      const { dispatch, history } = this.props;

      console.log("Verifying OTP for email:", this.state.email);
      console.log("OTP entered:", otpValue);

      dispatch(
        authenticateActions.verifyOtp(this.state.email, otpValue,
          () => {
            this.setState({ isLoading: false });
            // Redirect based on permissions
            if (getPermissionByName('dashboard'))      history.push('/dashboard');
            else if (getPermissionByName('map'))       history.push('/map');
            else if (getPermissionByName('search'))    history.push('/search');
            else if (getPermissionByName('reports'))   history.push('/ars-usage-report');
            else if (getPermissionByName('towSheets')) history.push('/tow-sheets');
            else history.push('/');
          },
          (fail) => {
            this.setState({
              isLoading: false,
              errorMessage: fail.statusMsg || 'Invalid verification code'
            });
            notify.createNotification('error', this.state.errorMessage, this.props.refNotify);
          }
        )
      );
    }
  }

  switchToPasswordLogin() {
    this.props.onSwitchLoginMode();
  }

  render() {
    const { showOtpForm, isLoading, errorMessage, email, otp } = this.state;

    const emailConfig = {
      email: {
        isRequired: "Email is required!",
        isEmail:    "Please enter a valid email address"
      }
    };

    const otpConfig = {
      otp: {
        isRequired:  "Verification code is required!",
        isMinLength: { message: "Code must be 6 digits", length: 6 },
        isMaxLength: { message: "Code must be 6 digits", length: 6 }
      }
    };

    return (
      <Fragment>
        <div className="panel-body">
          {!showOtpForm ? (
            // First form: Email input
            <FormValidation
              name="frmMfaEmail"
              className="mb-lg"
              config={emailConfig}
              onSubmit={this.handleEmailSubmit}
            >
              {({ fields, errors, submitted, handleChange }) => (
                <Fragment>
                  <h4 className="text-center mb-lg">MFA Login</h4>
                  <p className="text-center">Enter your email to receive a verification code</p>

                  <div className={
                    submitted && errors.email
                      ? "form-group has-feedback has-error has-danger"
                      : "form-group has-feedback"
                  }>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="Enter your email"
                      className="form-control"
                      value={fields.email}
                      onChange={handleChange}
                      disabled={isLoading}
                    />
                    <span className="fa fa-envelope form-control-feedback text-muted"></span>
                    {submitted && errors.email && (
                      <div className="invalid-feedback with-errors">
                        <span className="text-danger">{errors.email}</span>
                      </div>
                    )}
                  </div>

                  {errorMessage && (
                    <div className="alert alert-danger">{errorMessage}</div>
                  )}

                  <div className="clearfix">
                    <div className="pull-right">
                      <Link
                        to="#"
                        onClick={this.switchToPasswordLogin}
                        className="text-muted"
                      >
                        Use password login instead
                      </Link>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-block btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Sending...' : 'Send Verification Code'}
                  </button>
                </Fragment>
              )}
            </FormValidation>
          ) : (
            // Second form: OTP input
            <FormValidation
              name="frmMfaOtp"
              className="mb-lg"
              config={otpConfig}
              onSubmit={this.handleOtpSubmit}
              initialValues={{ otp }} // Pre-populate with state value
            >
              {({ fields, errors, submitted, handleChange }) => (
                <Fragment>
                  <h4 className="text-center mb-lg">Enter Verification Code</h4>
                  <p className="text-center">
                    We've sent a verification code to {email}
                  </p>

                  <div className={
                    submitted && errors.otp
                      ? "form-group has-feedback has-error has-danger"
                      : "form-group has-feedback"
                  }>
                    <input
                      id="otp"
                      name="otp"
                      type="text"
                      placeholder="Enter 6-digit code"
                      className="form-control"
                      value={fields.otp || otp} // Fallback to state if fields.otp is undefined
                      onChange={(e) => {
                        if (typeof handleChange === 'function') {
                          handleChange(e); // Update form validation state
                        }
                        this.handleOtpChange(e); // Update component state
                      }}
                      disabled={isLoading}
                      maxLength={6}
                    />
                    <span className="fa fa-lock form-control-feedback text-muted"></span>
                    {submitted && errors.otp && (
                      <div className="invalid-feedback with-errors">
                        <span className="text-danger">{errors.otp}</span>
                      </div>
                    )}
                  </div>

                  {errorMessage && (
                    <div className="alert alert-danger">{errorMessage}</div>
                  )}

                  <div className="clearfix">
                    <div className="pull-left">
                      <Link
                        to="#"
                        onClick={() => this.setState({ showOtpForm: false })}
                        className="text-muted"
                      >
                        Back
                      </Link>
                    </div>
                    <div className="pull-right">
                      <Link
                        to="#"
                        onClick={() =>
                          this.handleEmailSubmit(
                            { fields: { email }, isValid: true }
                          )
                        }
                        className="text-muted"
                      >
                        Resend code
                      </Link>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-block btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Verifying...' : 'Verify Code'}
                  </button>
                </Fragment>
              )}
            </FormValidation>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authInfo: state.authInfo,
  refNotify: state.refNotify
});

export default withRouter(connect(mapStateToProps)(MfaLogin));